import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input } from "../../../components/form";
import { Button } from "../../../components/button";

interface IJobTitleForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const JobTitleForm: React.FC<IJobTitleForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
